// extracted by mini-css-extract-plugin
export default {"title":"L9CWs","address":"rJ_ip"};